import {
  FieldSkeleton,
  HeaderSkeleton,
  Line,
  SkeletonRegion,
} from '@ems/ui/patterns/skeleton-blocks'

/** The profile page: two short form sections. */
export function ProfileSkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-6">
      <HeaderSkeleton title="w-20" description="w-80" />
      <div className="flex max-w-xl flex-col gap-8">
        <div className="flex flex-col gap-4">
          <Line width="w-32" />
          <FieldSkeleton label="w-20" />
          <FieldSkeleton label="w-24" />
        </div>
        <div className="flex flex-col gap-4">
          <Line width="w-16" />
          <FieldSkeleton label="w-12" help="w-80" />
          <FieldSkeleton label="w-14" />
        </div>
      </div>
    </SkeletonRegion>
  )
}
